import z from "zod";

/**
 * Zod schema that transforms and normalizes SQL strings:
 * - Trims leading/trailing whitespace
 * - Collapses multiple whitespace characters (spaces, tabs, newlines) into single spaces
 * - Normalizes spacing around operators and punctuation
 * - Removes whitespace before commas and semicolons
 * - Ensures single space after commas
 * - Removes whitespace inside parentheses
 */
export const normalizedSqlSchema = z.string().transform((sql) => {
  return (
    sql
      // REMOVE single-line comments
      .replace(/^\s*--.*$/gm, "")
      // Remove empty lines
      .replace(/^\s*\n/gm, "")
      // Collapse spaces/tabs only
      .replace(/[ \t]+/g, " ")
      // remove leading whitespace per line
      .replace(/^[ \t]+/gm, "")
      // remove trailing whitespace per line
      .replace(/[ \t]+$/gm, "")
      // Trim leading and trailing whitespace
      .trim()
  );
});

/**
 * Normalizes a SQL string by removing extra whitespace, newlines,
 * and ensuring consistent formatting.
 */
export const normalizeSql = (sql: string): string => {
  if (!sql) return "";
  return normalizedSqlSchema.parse(sql);
};
